import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Ai, Check, Search as SearchIcon, TriangleDown } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { memo, useCallback, useMemo, useState } from "react";
import { usePrivateSearchContext } from "~/providers/PrivateSearchProvider";
export const SearchCommandModeSelector = /*#__PURE__*/ memo((param)=>{
    let { className, search } = param;
    const { canUseSmartSearch, searchType, setSearchType } = usePrivateSearchContext();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const hasSearchTerm = !!search && search.trim().length > 0;
    const handleSearchIconClick = useCallback((e)=>{
        if (canUseSmartSearch) {
            e.stopPropagation();
        // The dropdown will handle the search type selection
        }
    }, [
        canUseSmartSearch
    ]);
    const handleOpenChange = useCallback((open)=>{
        setIsDropdownOpen(open);
    }, []);
    const searchTypeOptions = useMemo(()=>[
            {
                id: "keyword",
                label: "Exact search",
                onSelect: ()=>setSearchType("keyword"),
                type: "item",
                prefix: /*#__PURE__*/ _jsx(SearchIcon, {
                    "data-testid": "DROPDOWN_SEARCH_ICON",
                    className: "size-4 text-grey-10"
                }),
                suffix: searchType === "keyword" ? /*#__PURE__*/ _jsx(Check, {
                    "data-testid": "EXACT_SEARCH_CHECK_ICON",
                    className: "size-4 text-grey-10"
                }) : undefined
            },
            {
                id: "smart",
                label: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: "Smart search"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "rounded-full bg-grey-4 px-[6px] py-[3px] text-[10px] font-bold uppercase leading-[12px] tracking-[0.4px] text-grey-11",
                            children: "BETA"
                        })
                    ]
                }),
                onSelect: ()=>setSearchType("smart"),
                type: "item",
                prefix: /*#__PURE__*/ _jsx(Ai, {
                    "data-testid": "DROPDOWN_AI_ICON",
                    className: "size-4 text-grey-10"
                }),
                suffix: searchType === "smart" ? /*#__PURE__*/ _jsx(Check, {
                    "data-testid": "SMART_SEARCH_CHECK_ICON",
                    className: "size-4 text-grey-10"
                }) : undefined
            }
        ], [
        setSearchType,
        searchType
    ]);
    const searchIcon = /*#__PURE__*/ _jsxs("button", {
        className: tailwindMerge("flex cursor-pointer items-center gap-0.5 rounded-full bg-grey-1 px-1 py-0.5 hover:bg-grey-4", isDropdownOpen && "bg-grey-4", className),
        onClick: handleSearchIconClick,
        children: [
            searchType === "smart" ? /*#__PURE__*/ _jsx(Ai, {
                "data-testid": "BUTTON_AI_ICON",
                className: classNames("m-0.5 size-4 shrink-0", !hasSearchTerm && "text-grey-10"),
                style: {
                    color: hasSearchTerm ? "#6E56CF" : undefined
                }
            }) : /*#__PURE__*/ _jsx(SearchIcon, {
                "data-testid": "BUTTON_SEARCH_ICON",
                className: "m-0.5 size-4 shrink-0 text-grey-10"
            }),
            /*#__PURE__*/ _jsx(TriangleDown, {
                "data-testid": "TRIANGLE_DOWN_ICON",
                className: "size-4 shrink-0 text-grey-10"
            })
        ]
    });
    return canUseSmartSearch ? /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: searchIcon,
        align: "start",
        side: "bottom",
        size: "large",
        sideOffset: 4,
        open: isDropdownOpen,
        onOpenChange: handleOpenChange,
        className: "w-[280px]",
        children: renderDropdownItems({
            options: searchTypeOptions
        })
    }) : /*#__PURE__*/ _jsx(SearchIcon, {
        "data-testid": "FALLBACK_SEARCH_ICON",
        className: "size-4 shrink-0 text-grey-10"
    });
});
SearchCommandModeSelector.displayName = "SearchCommandModeSelector";
